var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66 65",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.255 3.384a29.5 29.5 0 0 1-3.419 6.064c-8.169-8.203-20.123-11.371-31.283-8.29S3.759 13.092.956 24.324s.661 23.104 9.064 31.067l1.186 1.047a32.08 32.08 0 0 0 52.67-22.253c.875-8.17-1.524-18.5-5.62-30.8zm-43.67 52.193c-.698.863-1.848 1.22-2.912.905s-1.834-1.241-1.95-2.345.445-2.169 1.421-2.698 2.175-.418 3.037.282c1.176.954 1.357 2.68.404 3.857zm43.538-9.6c-7.92 10.55-24.83 7-35.672 7.502 0 0-1.922.113-3.857.43l1.663-.663c7.614-2.65 11.213-3.16 15.838-5.54 8.708-4.427 17.322-14.122 19.112-24.2-3.313 9.695-13.373 18.032-22.53 21.418-6.276 2.313-17.614 4.566-17.614 4.566l-.457-.245c-7.714-3.76-7.951-20.466 6.077-25.856 6.143-2.366 12.02-1.067 18.654-2.65 7.084-1.683 15.28-7 18.615-13.916 3.73 11.08 8.224 28.422.166 39.15z",
    stroke: "none",
    fill: "#68bd45",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpring);
export default __webpack_public_path__ + "static/media/spring.37a09d4f0c0bd7682e183cb8429220a7.svg";
export { ForwardRef as ReactComponent };